
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 30 31","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_5501_20200)","fill":"#29757A"}},[_c('path',{attrs:{"d":"M5 23.337h8.466a.75.75 0 100-1.5H5a3.254 3.254 0 01-3.25-3.25v-5.06a51.496 51.496 0 0010.8 1.277h.069a50.031 50.031 0 0011.817-1.6.748.748 0 00.55-.722v-1.436a5.349 5.349 0 00-5.343-5.343h-1.524V5.09A4.339 4.339 0 0013.785.756h-2.334A4.34 4.34 0 007.117 5.09v.613H5.593A5.349 5.349 0 00.25 11.046v7.541A4.756 4.756 0 005 23.337zM8.617 5.09a2.837 2.837 0 012.834-2.834h2.334a2.837 2.837 0 012.834 2.834v.613h-8l-.002-.613zM1.75 11.046a3.847 3.847 0 013.843-3.843h14.05a3.847 3.847 0 013.843 3.843v.856a49.309 49.309 0 01-10.869 1.4h-.065a50.817 50.817 0 01-10.8-1.319l-.002-.937z"}}),_c('path',{attrs:{"d":"M16.865 22.463c0 1.43.48 2.819 1.36 3.945l-2.068 2.068a.75.75 0 101.061 1.06l2.057-2.057a6.437 6.437 0 10-2.41-5.016zm11.385 0a4.943 4.943 0 11-9.886 0 4.943 4.943 0 019.886 0zM14.562 11.09a.75.75 0 00-.75-.75h-2.343a.75.75 0 000 1.5h2.343a.75.75 0 00.75-.75z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_5501_20200"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .256)","d":"M0 0h30v30H0z"}})])])])
          )
        }
      }
    